// Final steps section questionnaire constants
// Extract relevant constants from main questionnaire enum
export enum FinalStepsQuestionnaireItem {
  FINAL_STEPS = 'final-steps',
  FINAL_STEPS_INTERNAL_NOTES = 'final-steps/internal-notes',
  FINAL_STEPS_CLIENT_REPRESENTATIVE_SIGNATURE = 'final-steps/client-representative-signature'
}
